export default __webpack_public_path__ + "0343333fa0c92ce27fe8e0e8a6f4321d.svg";